<script lang="ts">
  let {
    value = 'full_disclosure',
    onChange = (_value: string) => {},
    size = 'md' as 'sm' | 'md',
    disabled = false
  }: {
    value?: string
    onChange?: (value: string) => void
    size?: 'sm' | 'md'
    disabled?: boolean
  } = $props()

  const options = [
    {
      value: 'full_disclosure',
      icon: '🌐',
      label: '전체',
      description: '실명 + 회사정보'
    },
    {
      value: 'company_only',
      icon: '🏢',
      label: '회사',
      description: '닉네임 + 회사정보'
    },
    {
      value: 'name_only',
      icon: '👤',
      label: '이름',
      description: '실명만 표시'
    },
    {
      value: 'anonymous',
      icon: '🔒',
      label: '익명',
      description: '닉네임만 표시'
    }
  ]

  const sizeClasses = {
    sm: 'text-sm gap-1',
    md: 'text-base gap-2'
  }
</script>

<div class="privacy-selector">
  <span class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
    공개 범위 선택
  </span>
  <div class="grid grid-cols-4 gap-2">
    {#each options as option}
      <button
        type="button"
        onclick={() => !disabled && onChange(option.value)}
        disabled={disabled}
        class="flex flex-col items-center rounded-xl border-2 p-3 transition-all cursor-pointer
               bg-white dark:bg-gray-800
               {value === option.value
                 ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
                 : 'border-gray-200 dark:border-gray-600 hover:border-blue-300 dark:hover:border-blue-500'}
               disabled:opacity-50 disabled:cursor-not-allowed
               {sizeClasses[size]}"
      >
        <span class="text-2xl">{option.icon}</span>
        <span class="font-medium text-gray-900 dark:text-white">{option.label}</span>
        <span class="text-xs text-gray-500 dark:text-gray-400">{option.description}</span>
      </button>
    {/each}
  </div>
</div>
